import MachineProductionDetails from "@/stores/modules/machineProduction/MachineProductionDetailsModule";
import MachineProductionTimeline from "@/stores/modules/machineProduction/MachineProductionTimelineModule";
import MachineProductionComponents from "@/stores/modules/machineProduction/MachineProductionComponentsModule";

export default {
  state: {
    active: false
  },
  getters: {
    active: state => state.active
  },
  actions: {
    subscribe: ({ dispatch, commit, getters, rootGetters }) => {
      const machine = rootGetters["Machine/getSelected"];

      if (!getters.active && machine && machine.Device) {
        let family = machine.MachineFamily ? machine.MachineFamily.toLowerCase() : "";
        let template_components = "";

        // Check CMS
        if (machine.TicketManager && machine.TicketManager === "CMS") {
          family = "cms";
        }

        switch (family) {
          case "cms":
            break;
          // SEZ
          case "beam_saw":
          case "sez":
            template_components = {
              template: "SEZ",
              enableFeedOverride: true
            };
            break;
          // FOR
          case "bor":
          case "boring":
          case "boring_machine":
            template_components = {
              template: "BOR",
              enableSpeedOverride: true,
              enableFeedOverride: true
            };
            break;
          // BOR
          case "eba":
          case "edge_bander":
            template_components = {
              template: "EBA"
            };
            break;
          // CDL
          case "cnc_machine":
          case "cdl":
          default:
            template_components = {
              enableSpeedOverride: true,
              enableFeedOverride: true
            };
            break;
        }

        dispatch("MachineProductionComponents/subscribe", template_components);
        dispatch("MachineProductionDetails/subscribe");
        dispatch("MachineProductionTimeline/subscribe");
      }
      commit("ACTIVATE");
    },

    unsubscribe: ({ dispatch, commit, getters, rootGetters }) => {
      if (getters.active && !!rootGetters["Machine/getSelected"].Device) {
        dispatch("MachineProductionDetails/unsubscribe");
        dispatch("MachineProductionTimeline/unsubscribe");
        dispatch("MachineProductionComponents/unsubscribe");
      }
      commit("RESET");
    }
  },
  mutations: {
    ACTIVATE: state => {
      state.active = true;
    },
    RESET: state => {
      //qui tutte le manipolazioni del caso
      state.active = false;
    }
  },
  namespaced: true,
  modules: {
    MachineProductionDetails,
    MachineProductionTimeline,
    MachineProductionComponents
  }
};
